import Version from "./v";

export default Version;
